{
	"eventReports": {
		"refunded": {
			"zigTable": "Mesa Zig",
			"zigTag": "Tarjeta Zig",
			"zigFicha": "Ficha Zig"
		}
	}
}
